const baseURL = "https://api.cafe-sciences.org";
export default baseURL;
